var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('apexchart',{attrs:{"width":"100%","type":"bar","options":_vm.options,"series":_vm.series}}):_c('center',[_c('strong',[_vm._v("Não encontramos dados.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }